"use strict";
/**
 * Created on 04 22 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var ProductSuppliers_1 = require("../../supply/model/ProductSuppliers");
/**
 * <p>Extension of {@link ProductSuppliers} about identification of {@link WindowItem}. This is kind of DTO object, selected suppliers
 * related to particular window item should be associated with {@link SupplierAgreement}.</p>
 *
 * @author JMe
 */


var WindowItemProductSuppliers =
/*#__PURE__*/
function (_ProductSuppliers_1$P) {
  _inherits(WindowItemProductSuppliers, _ProductSuppliers_1$P);

  /**
   * @param itemId Corresponds to {@link WindowItem.id}.
   * @param productId Corresponds to {@link ProductSuppliers.productId}.
   * @param preferredSupplierId Corresponds to {@link ProductSuppliers.preferredSupplierId}.
   * @param supplierIds Corresponds to {@link ProductSuppliers.supplierIds}.
   */
  function WindowItemProductSuppliers(itemId, productId, preferredSupplierId, supplierIds) {
    var _this;

    _classCallCheck(this, WindowItemProductSuppliers);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemProductSuppliers).call(this, productId, preferredSupplierId, supplierIds));
    _this.itemId = itemId;
    _this.productId = productId;
    _this.preferredSupplierId = preferredSupplierId;
    _this.supplierIds = supplierIds;
    return _this;
  }

  return WindowItemProductSuppliers;
}(ProductSuppliers_1.ProductSuppliers);

exports.WindowItemProductSuppliers = WindowItemProductSuppliers;

WindowItemProductSuppliers.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowItemProductSuppliers.name);
  return {
    itemId: builder.id('itemId'),
    productId: builder.id('productId'),
    preferredSupplierId: builder.opt(builder.id('preferredSupplierId')),
    supplierIds: builder.setOf(builder.id('supplierIds'))
  };
}();